import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import tallHouse from "../../assets/img/tall-house.jpg";
import { MdCenterFocusStrong, MdCompare, MdFindInPage } from 'react-icons/md';
import { GiTargetShot } from 'react-icons/gi';
import { FaUsers, FaPlug } from 'react-icons/fa';

const About = () => {
  return (
    <div id="about">
      <Header />
      <main>
        <section className="intro-area">
          <div className="intro-area_wrap center container">
            <h1>About Us</h1>
          </div>
        </section>
        <section className="container">
          <div className="about-brief">
            <div className="about-brief_detail">
              <h2>Leading Property Advertising Website</h2>
              <p>A realty website in Nigeria with varieties of property listings ranging from Flats, Houses, Land & Commercial Property all for lease, Rent and Sale. We bring a special blend of carefully curated property listings to your fingertips.</p>
              <p>Today, Island Luxury Property Listings is one of the leading property advertising website with growing users, advertising members and unlimited property choices all around Nigeria. Our verified Property professionals such as estate agents, letting (rental) agents, new homes developers and Nigerian private property owners offer Latest Property for Sale or for Rent in and across Nigeria.</p>
              <p>We are a hub for International organizations and Nigerian private property owners as well as top class realtors to showcase premium properties like homes, houses, lands, shops, office spaces and other commercial properties to buy or rent, to Nigerian property seekers.</p>
              <NavLink to="/signup">POST PROPERTY FOR FREE</NavLink>
            </div>
            <div className="about-brief_img">
              <img src={tallHouse} alt="Tall House" />
            </div>
          </div>
        </section>
        <section className="mision-vision">
          <div className="mv_grid container">
            <div className="mv_grid-item">
              <div className="mv_grid-icon">
                <GiTargetShot size={55} />
              </div>
              <h2>Our Mission</h2>
              <p>Our overall goal is to give our esteemed customers, carefully curated luxury properties without stress, all within reasonable price.</p>
            </div>
            <div className="mv_grid-item">
              <div className="mv_grid-icon">
                <MdCenterFocusStrong size={55} />
              </div>
              <h2>Our Vision</h2>
              <p>To be the leading online realty website in Africa</p>
            </div>
          </div>
        </section>
        <section className="our-services container">
          <h1>Our Services</h1>
          <div className="our-services_grid">
            <div className="our-serv_card">
              <div className="our-serv_icon">
                <FaUsers size={40} />
              </div>
              <h3>Gain maximum exposure for your properties</h3>
            </div>
            <div className="our-serv_card">
              <div className="our-serv_icon">
                <FaPlug size={40} />
              </div>
              <h3>Surest plug to buy and sell luxury properties</h3>
            </div>
            <div className="our-serv_card">
              <div className="our-serv_icon">
                <MdCompare size={40} />
              </div>
              <h3>Compare property prices</h3>
            </div>
            <div className="our-serv_card">
              <div className="our-serv_icon">
                <MdFindInPage size={40} />
              </div>
              <h3>Find the right property that meet your need.</h3>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}

export default About;